import { SearchResults } from "../../Shared/scriptts/interfaces";
import { params, aliasMapping, searchFilters, brandedSearch, executeSearchUrl, displayResults } from '../search-main';
import { addToArrayParam, isBrandedSearchFilter, removeFromArrayParam } from '../search-filters-main';
import { URLCriteriaHelper } from '../search-urlcriteriahelper';

/**
 * Display filters that have no partial specified in .Net code
 * @param data The data returned from the search API
 */
export function displayNoPartialFilters(data: SearchResults) {
    setFilterCounts(data);
    searchFilters.forEach(filter => {
        if (filter.Partial) {
            return;
        }
        const inBrandedSearch = brandedSearch && brandedSearch.SelectedFilters.find(f => f == filter.FilterType) !== undefined;
        const hasBrandedSearchValue = inBrandedSearch && brandedSearch[aliasMapping[filter.FilterType].JOAQueryName] !== undefined;

        if (hasBrandedSearchValue) {
            document.querySelector<HTMLButtonElement>(`#select-all-${filter.FilterType}`)?.classList.add('hidden');
        }
        else {
            document.querySelector<HTMLButtonElement>(`#select-all-${filter.FilterType}`)?.addEventListener('click', toggleAllFilterItemsClicked);
        }

        document.querySelectorAll<HTMLInputElement>(`[name=${filter.FilterType}]`).forEach(input => {
            input.addEventListener('change', filterItemChanged);
            input.checked = params[aliasMapping[input.name]?.JOAQueryName?.toString()]?.indexOf(input.value) > -1;
            if (hasBrandedSearchValue) {
                if (!isBrandedSearchFilter(input.name, input.value)) {
                    document.querySelector<HTMLElement>(`#li-${input.id}`)?.classList.add('hidden');
                }
            }
        });
        const titleElem = document.querySelector<HTMLElement>(`#titleaccordion-${filter.FilterType}`);
        if (titleElem === null) {
            return;
        }
        const countIcon = document.querySelector<HTMLElement>(`#count-${filter.FilterType}`) || document.createElement('span');
        const propertyName = [aliasMapping[filter.FilterType]?.JOAQueryName]?.toString();
        countIcon.id = `count-${filter.FilterType}`;
        countIcon.className = params[propertyName]?.length > 0 ? 'bg-warning rounded-full py-1 px-2 ml-2' : 'bg-warning rounded-full py-1 px-2 ml-2 hidden';
        countIcon.innerText = params[propertyName]?.length.toString();
        if (!titleElem.contains(countIcon)) {
            titleElem.appendChild(countIcon);
        }
        setSelectAllText(filter.FilterType);
    });
}

function toggleAllFilterItemsClicked(evt: Event) {
    const toggleButton = <HTMLButtonElement>(evt.target);
    const filterType = toggleButton.getAttribute('data-filter-type') ?? '';
    const dataSelected = toggleButton.getAttribute('data-selected') ?? 'false';
    const filterInputs = document.querySelectorAll<HTMLInputElement>(`[name=${filterType}]`);
    const paramProperty = aliasMapping[filterInputs[0]?.name]?.JOAQueryName?.toString();

    toggleButton.setAttribute('data-selected', dataSelected === 'true' ? 'false' : 'true');
    document.querySelectorAll<HTMLInputElement>(`[name=${filterType}]`).forEach(input => {
        input.checked = !(dataSelected === 'true');
        if (input.checked) {
            addToArrayParam(paramProperty, input.value);
        }
        else {
            removeFromArrayParam(paramProperty, input.value);
        }
    });

    setSelectAllText(filterType);
    displayResults(executeSearchUrl, false, true);
    setCountIconDisplay(paramProperty, filterType);
    URLCriteriaHelper.reconstructUrl();
}

function filterItemChanged(evt: Event) {
    const itemElem = <HTMLInputElement>(evt.target);
    const filterType = itemElem.name ?? '';
    const propertyName = aliasMapping[itemElem.name]?.JOAQueryName?.toString();
    
    if (itemElem.checked) {
        let allSelected = 'true';
        if (params[propertyName]?.indexOf(itemElem.value) === -1) {
            params[propertyName]?.push(itemElem.value);
        }
        const toggleButton = document.querySelector<HTMLButtonElement>(`#select-all-${filterType}`);
        if (!toggleButton) {
            return;
        }
        document.querySelectorAll<HTMLInputElement>(`[name=${filterType}]`).forEach(input => {
            if (!input.checked) {
                allSelected = 'false';
            }
        });
        toggleButton.setAttribute('data-selected', allSelected);
        setSelectAllText(filterType);
    }
    else {
        params[propertyName]?.splice(params[propertyName]?.indexOf(itemElem.value), 1);
        const toggleButton = document.querySelector<HTMLButtonElement>(`#select-all-${filterType}`);
        if (toggleButton) {
            toggleButton.setAttribute('data-selected', 'false');
            setSelectAllText(filterType);
        }
    }
    params.Page = '1';
    displayResults(executeSearchUrl, false, true);
    setCountIconDisplay(propertyName, filterType);
    URLCriteriaHelper.reconstructUrl();
}

function setCountIconDisplay(paramProperty, filterType: string) {
    const countIcon = document.querySelector<HTMLElement>(`#count-${filterType}`);
    if (countIcon === null) {
        return;
    }
    const count = params[paramProperty]?.length;
    if (count > 0) {
        countIcon.innerText = count.toString();
        countIcon.classList.remove('hidden');
    }
    else {
        countIcon.innerText = '0';
        countIcon.classList.add('hidden');
    }
}

function setSelectAllText(filterType: String) {
    const elem = document.querySelector<HTMLButtonElement>(`#select-all-${filterType}`);
    if (!elem) {
        return;
    }
    const inputs = document.querySelectorAll<HTMLInputElement>(`[name=${filterType}]`);
    let isAllSelected = true;

    for (let i = 0; i < inputs.length; i++) {
        if (!inputs[i].checked) {
            isAllSelected = false;
            break;
        }
    }
    if (isAllSelected) {
        elem.setAttribute('data-selected', 'true');
        elem.innerText = 'Deselect all';
        elem.title = elem.title.replace('Select', 'Deselect');
    }
    else {
        elem.setAttribute('data-selected', 'false');
        elem.innerText = 'Select all';
        elem.title = elem.title.replace('Deselect', 'Select');
    }
}

function setFilterCounts(data: SearchResults) {
    searchFilters.forEach((filter) => {
        if (filter.Partial) {
            return;
        }
        const codeCounts = data.f[aliasMapping[filter.FilterType].Abbreviation];
        if (filter.FilterGroup) {
            filter.FilterGroup.forEach((group, groupIndex) => {
                group.Count = 0;
                group.Items?.forEach(item => {
                    item.Count = codeCounts && codeCounts.hasOwnProperty(item.Value) ? codeCounts[item.Value] : 0;
                    group.Count += item.Count;
                    const itemCountElem = document.querySelector<HTMLElement>(`#item-count-${filter.FilterType}-${item.Value}`);
                    if (!itemCountElem) {
                        return;
                    }
                    itemCountElem.innerText = `(${item.Count})`;
                });
                const groupCountElem = document.querySelector<HTMLElement>(`#group-count-${filter.FilterType}-${groupIndex}`);
                if (!groupCountElem) {
                    return;
                }
                groupCountElem.innerText = `(${group.Count})`;
            });
        }
        else {
            filter.Items.forEach(item => {
                const itemCountElem = document.querySelector<HTMLElement>(`#item-count-${filter.FilterType}-${item.Value}`);
                if (!itemCountElem) {
                    return;
                }
                item.Count = codeCounts && codeCounts.hasOwnProperty(item.Value) ? codeCounts[item.Value] : 0;
                itemCountElem.innerText = `(${item.Count})`;
            });
        }
    });
}
